(() => {
  if (customElements.get('cl-testimonials-carousel')) return;

  class ClTestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.hasConnected) return;

      this.hasConnected = true;
      this.carousel = this.querySelector('[data-testimonials-slider]');
      this.slides = Array.from(this.querySelectorAll('[data-testimonial-index]'));
      this.previousButton = this.querySelector('[data-testimonials-previous]');
      this.nextButton = this.querySelector('[data-testimonials-next]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handleBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      if (!this.carousel || this.slides.length === 0) return;

      this.waitForSwiper();
    }

    disconnectedCallback() {
      this.hasConnected = false;
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);

      if (this.swiperWaitTimer) {
        window.clearTimeout(this.swiperWaitTimer);
        this.swiperWaitTimer = null;
      }

      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.destroy(true, true);
      }

      this.swiper = null;
    }

    waitForSwiper(attempt = 0) {
      if (!this.isConnected) return;

      if (typeof window.Swiper === 'function') {
        this.initializeCarousel();
        return;
      }

      if (attempt >= 100) return;

      this.swiperWaitTimer = window.setTimeout(() => {
        this.waitForSwiper(attempt + 1);
      }, 50);
    }

    initializeCarousel() {
      if (this.swiper || !this.carousel) return;

      this.swiper = new window.Swiper(this.carousel, {
        slidesPerView: 1.08,
        slidesPerGroup: 1,
        spaceBetween: 14,
        speed: this.reducedMotion ? 0 : 400,
        allowTouchMove: this.slides.length > 1,
        simulateTouch: true,
        grabCursor: this.slides.length > 1,
        loop: false,
        rewind: false,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        navigation: {
          prevEl: this.previousButton,
          nextEl: this.nextButton,
          disabledClass: 'is-disabled',
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Depoimento anterior',
          nextSlideMessage: 'Próximo depoimento',
          firstSlideMessage: 'Este é o primeiro depoimento',
          lastSlideMessage: 'Este é o último depoimento',
        },
        breakpoints: {
          480: {
            slidesPerView: 1.25,
            spaceBetween: 16,
          },
          750: {
            slidesPerView: 1.65,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 2.25,
            spaceBetween: 24,
          },
          1200: {
            slidesPerView: 2.45,
            spaceBetween: 28,
          },
        },
        on: {
          init: (swiper) => this.updateNavigation(swiper),
          slideChange: (swiper) => this.updateNavigation(swiper),
          resize: (swiper) => this.updateNavigation(swiper),
          breakpoint: (swiper) => this.updateNavigation(swiper),
        },
      });
    }

    onBlockSelect(event) {
      if (!this.swiper || this.swiper.destroyed) return;

      const selectedSlide = event.target.closest('[data-testimonial-index]');
      if (!selectedSlide) return;

      const targetIndex = this.slides.indexOf(selectedSlide);
      if (targetIndex < 0) return;

      this.swiper.slideTo(targetIndex, 0);
    }

    updateNavigation(swiper) {
      if (!swiper) return;

      const disablePrevious = this.slides.length <= 1 || swiper.isBeginning;
      const disableNext = this.slides.length <= 1 || swiper.isEnd;

      this.setButtonState(this.previousButton, disablePrevious);
      this.setButtonState(this.nextButton, disableNext);
    }

    setButtonState(button, disabled) {
      if (!button) return;

      button.disabled = disabled;
      button.setAttribute('aria-disabled', String(disabled));
      button.classList.toggle('is-disabled', disabled);
    }
  }

  customElements.define('cl-testimonials-carousel', ClTestimonialsCarousel);
})();
